import Cookies from "universal-cookie";
import { createAuthenticatedFetch } from "./authenticatedFetch";

const cookies = new Cookies();
const fetch = createAuthenticatedFetch({
  serverUrl: process.env.SERVER_URL,
  getToken: () => cookies.get("userId")?.token,
  fetchImpl: (...args) => globalThis.fetch(...args),
});

export const uploadPresigned = async (newFile, building_id, building_name, company_id) => {
  // Request presigned URL
  const { file, name } = newFile;
  const metaRes = await fetch(`${process.env.SERVER_URL}/project/uploadFile`, { // same endpoint
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ filename: name || file.name, contentType: file.type, usePresigned: true, building_id: building_id, building_name: building_name, company_id: company_id })
  });
  const { url, key } = await metaRes.json();

  // Upload directly to S3
  const putRes = await fetch(url, {
    method: "PUT",
    headers: { "Content-Type": file.type },
    body: file
  });

  if (!putRes.ok) throw new Error("Upload failed");
}

export const uploadSmall = async (newFile, building_id, building_name, company_id) => {
  const { file, name } = newFile;
  const base64 = await new Promise(resolve => {
    const r = new FileReader();
    r.onload = () => resolve(r.result.split(',')[1]);
    r.readAsDataURL(file);
  });

  const res = await fetch(`${process.env.SERVER_URL}/project/uploadFile`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      filename: name || file.name,
      contentType: file.type,
      contentBase64: base64,
      building_id: building_id,
      building_name: building_name,
      company_id: company_id,
      usePresigned: false // explicitly request direct
    })
  });

  return res.status;
}

export const getFiles = async (action, building_ids, fileId = "") => {
  const res = await fetch(`${process.env.SERVER_URL}/project/getFiles?building_ids=${building_ids.join(',')}&action=${action}&fileId=${fileId}`, {
    method: "GET",
    headers: { "Content-Type": "application/json" }
  });

  const files = await res.json();
  return files;
}
